<mat-form-field class="ed-select w-100">
    <mat-select
        [value]="value"
        [placeholder]="placeholder"
        [id]="innerId"
        [disableRipple]="disableRipple"
        [disableOptionCentering]="disableOptionCentering"
        [disabled]="disabled"
        panelClass="ed-select"
        (selectionChange)="changeValue($event.value)">
        <mat-option
            *ngFor="let option of options"
            [value]="option.value"
            [disabled]="option.disabled">
            {{ option.label }}
        </mat-option>
    </mat-select>
</mat-form-field>
